import { render, staticRenderFns } from "./Login_Page.vue?vue&type=template&id=963c209c&scoped=true&"
import script from "./Login_Page.vue?vue&type=script&lang=js&"
export * from "./Login_Page.vue?vue&type=script&lang=js&"
import style0 from "./Login_Page.vue?vue&type=style&index=0&id=963c209c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963c209c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
